import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-start mt-4"
};
const _hoisted_2 = {
  class: "media-list grid grid-cols-4 gap-2"
};
const _hoisted_3 = ["src", "alt", "aria-label", "onClick"];
const _hoisted_4 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted, computed, inject } from 'vue';
export default {
  __name: 'Tab1Dialog',
  props: {
    mediaOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['clickSure'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const dialogVisible = ref(false);
    const activeItem = ref({});
    const emit = __emit;
    const openDialog = data => {
      dialogVisible.value = true;
      selectMedia({});
    };
    const selectMedia = selectItem => {
      props.mediaOptions.forEach(item => {
        item.checked = false;
      });
      selectItem.checked = true;
      activeItem.value = selectItem;
    };
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleSure = () => {
      dialogVisible.value = false;
      emit('clickSure', activeItem.value);
    };

    // 生命周期
    onMounted(() => {});
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "geo-dialog",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "批量设置",
        width: "600px",
        "close-on-click-modal": false,
        "append-to-body": "",
        style: {
          "margin-top": "calc(50vh - 200px)"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "info",
          text: "",
          bg: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSure
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("确定", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "alert-hint"
        }, " 温馨提示：批量设置操作后将对所有文章生效，如果需要个性化操作请在单篇文章进行操作 ", -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaOptions, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "w-[94px] relative"
          }, [_createElementVNode("span", {
            class: _normalizeClass(["media-item", {
              'is-active': item.checked
            }])
          }, [_createElementVNode("img", {
            src: require('@/assets/images/' + item.ItemIco),
            alt: item.Title,
            "aria-label": `选择媒体: ${item.Title}`,
            onClick: $event => selectMedia(item)
          }, null, 8, _hoisted_3)], 2)]);
        }), 128))])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "text-[#86909C]"
        }, " 温馨提示：一篇文稿只能选择一个权威媒体 ", -1))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};